import { Component, Inject } from '@angular/core';
import { NotificationType } from '../notification.model';
import { DialogDataAcknowledge } from '@schir-int-client/dialog-shared';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'schir-int-client-dialog-acknowledge',
	templateUrl: './dialog-acknowledge.component.html',
	styleUrls: ['./dialog-acknowledge.component.scss'],
	standalone: false,
})
export class DialogAcknowledgeComponent {
	readonly notifcationTypes = NotificationType;

	constructor(@Inject(MAT_DIALOG_DATA) public data: DialogDataAcknowledge) {}
}
